<section class="section">
  <h1 class="section__title title-4">
    {{ title }}
  </h1>

  <div *ngIf="hasDescriptionAfterContent" class="section__content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>

  <p
    *ngIf="description"
    class="section__description body-sm"
    [class.section__description--after-content]="hasDescriptionAfterContent"
    [innerHtml]="description | safeHtml"
  ></p>

  <div *ngIf="!hasDescriptionAfterContent" class="section__content">
    <ng-container *ngTemplateOutlet="content"></ng-container>
  </div>

  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>
</section>
